<div class="holder">
  <div class="layer-1" [ngStyle]="style"></div>
  <div>
    <div class="name">{{name}}</div>
    <div class="title">{{title}}</div>
  </div>

</div>